// Pixi 8.9.2 never frees a destroyed renderer: module-level singletons keep
// references to every renderer ever created. Ones we've found:
//
// - getCanvasTexture's canvasCache holds each renderer's canvas until the canvas
//   texture is destroyed, and ViewSystem.destroy never destroys it (fixed in 8.13).
// - FilterSystem's shared quadGeometry keeps a 'destroy' listener from every
//   GlGeometrySystem that drew a filter, and GlGeometrySystem.destroy never
//   removes it or drops its VAOs (rewritten upstream later in 8.x).
// - Texture.EMPTY's source keeps 'change' listeners from per-renderer bind
//   groups, which lead back to the renderer.
//
// A leaked renderer is small on its own (its WebGL context is lost on destroy),
// but it holds its canvas, and @pixi/react destroys the app without removing
// the canvas from the DOM. The canvas's detached parents then keep the whole AG
// editor of every project opened in the session (~25 MB per open), which ran the
// renderer out of heap in long sessions. So a destroyed renderer always drops
// its canvas from the DOM, whatever else in Pixi still points at it.
import { GlGeometrySystem, ViewSystem } from 'pixi.js';

const destroyView = ViewSystem.prototype.destroy;

ViewSystem.prototype.destroy = function destroy(options) {
	destroyView.call(this, options);
	this.texture.destroy();
	this.canvas.remove?.(); // an OffscreenCanvas has no DOM to leave
};

const destroyGeometrySystem = GlGeometrySystem.prototype.destroy;

GlGeometrySystem.prototype.destroy = function destroy() {
	destroyGeometrySystem.call(this);
	// The listener on shared geometries stays, so keep the hash an object it can index.
	this._geometryVaoHash = Object.create(null);
};
